import React, { useMemo } from "react";
import classes from "./VideoPlayer.scss";
import ReactPlayer from "react-player";
import { showNewTheatreMode } from "Utils/GetTheatreModeType";
import VideoPlayerV2 from "./VideoPlayerV2";
import { allowURLWithCredentials } from "Utils/SecureUrlHelpers";

const VideoPlayer = React.memo(props => {
  const {
    videoUrl,
    isHLSUrl,
    autoPlay,
    getPlayerRef,
    onReady,
    containerStyle = {},
    showVideoPlayerV2 = false,
  } = props;

  const PlayerConfig = useMemo(() => {
    return {
      file: {
        forceHLS: isHLSUrl,
        hlsOptions: {
          xhrSetup: function (xhr, url) {
            xhr.withCredentials = allowURLWithCredentials(url);
          },
        },
      },
    };
  }, [isHLSUrl]);

  return showNewTheatreMode() && showVideoPlayerV2 ? (
    <VideoPlayerV2 {...props} />
  ) : (
    <div className={classes.container} style={containerStyle}>
      <ReactPlayer
        url={videoUrl}
        controls={true}
        className="reactPlayer"
        config={PlayerConfig}
        playing={autoPlay}
        ref={ref => {
          if (getPlayerRef) {
            getPlayerRef(ref);
          }
        }}
        onReady={onReady}
      />
    </div>
  );
});

VideoPlayer.displayName = "VideoPlayer";

VideoPlayer.defaultProps = {
  autoPlay: false,
};

export default VideoPlayer;
